package com.merkost.handpass.admin.auth

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.w3c.dom.events.Event
import org.w3c.dom.events.EventListener

@Composable
fun IdleTimeout(timeoutMs: Int, onTimeout: () -> Unit) {
    DisposableEffect(Unit) {
        var timerId = window.setTimeout({ onTimeout() }, timeoutMs)

        val handler = EventListener { _: Event ->
            window.clearTimeout(timerId)
            timerId = window.setTimeout({ onTimeout() }, timeoutMs)
        }

        val events = arrayOf("mousemove", "keydown", "mousedown", "touchstart")
        events.forEach { event ->
            window.addEventListener(event, handler)
        }

        onDispose {
            window.clearTimeout(timerId)
            events.forEach { event ->
                window.removeEventListener(event, handler)
            }
        }
    }
}
